<div
  class="status-badge"
  [class]="'status-badge--' + size() + ' status-badge--' + status()"
  [class.status-badge--rounded]="rounded()"
>
  @if (iconType() && resolvedIconPath(); as iconPathValue) {
    <app-svg-icon [icon]="iconPathValue" [blank]="true" class="status-badge__icon" />
  }
  <span class="status-badge__label">{{ label() }}</span>
</div>
